export const COURSE_INFO = 'courseInfo';
export const SPEEDGOLF_INFO = 'sgInfo';
export const SCORECARD = 'scorecard';
export const MAP = 'map';
